import React from "react";

const ACTION_BADGE = {
  created: "bg-[#ECFDF5] text-[#16A34A] ring-[#A7F3D0]",
  updated: "bg-accent-soft text-accent ring-[#99D5D2]",
  deleted: "bg-[#FEF2F2] text-[#DC2626] ring-[#FECACA]",
  restored: "bg-[#F5F3FF] text-[#7C3AED] ring-[#DDD6FE]",
};

export default function AuditActionBadge({ action }) {
  const cls =
    (action && ACTION_BADGE[action]) ??
    "bg-[#F6F8FB] text-[#64748B] ring-[#E2E8F0]";
  const label = action
    ? action.charAt(0).toUpperCase() + action.slice(1)
    : "Unknown";

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${cls}`}
    >
      {label}
    </span>
  );
}
